export type Agency = {
  id: string
  name: string
  logoBg: string
  logoText: string
  region: string
  size: string
  strong: string[]
  rating: number
  cases: number
  intro: string
}

export const agencies: Agency[] = [
  {
    id: 'g1',
    name: '指南者留学',
    logoBg: '#2b6ef5',
    logoText: '指',
    region: '南京',
    size: '大型',
    strong: ['英港新', '名校申请'],
    rating: 4.9,
    cases: 19223,
    intro: '专注海外名校申请，三对一服务体系，QS Top 100 录取业内领先。',
  },
  {
    id: 'g2',
    name: '环球教育',
    logoBg: '#10B981',
    logoText: '环',
    region: '北京',
    size: '大型',
    strong: ['美研', '商科'],
    rating: 4.6,
    cases: 12000,
    intro: '老牌留学机构，覆盖全球留学项目。',
  },
  {
    id: 'g3',
    name: '前程留学',
    logoBg: '#F59E0B',
    logoText: '前',
    region: '上海',
    size: '中型',
    strong: ['艺术留学'],
    rating: 4.7,
    cases: 5000,
    intro: '艺术留学专精，作品集辅导。',
  },
  {
    id: 'g4',
    name: '启航国际',
    logoBg: '#7C3AED',
    logoText: '启',
    region: '广州',
    size: '中型',
    strong: ['英联邦', '签证'],
    rating: 4.5,
    cases: 7500,
    intro: '英联邦留学专家，签证通过率行业领先。',
  },
]
